const colours = {
  red: "#D7004D",
  amber: "#FFAA05",
  green: "#1E7200"
};

export default colours;
